import * as React from 'react'
import { type VariantProps, cva } from 'class-variance-authority'
import { cn } from '~/lib/utils'

// 미니멀 라이트 버튼 — 시맨틱 토큰만 사용(하드코딩 hex 금지), 다크 자동 적응.
// React API(variant/size props·이름)는 그대로 유지해 콜사이트를 깨지 않는다.
const buttonVariants = cva(
    'inline-flex items-center justify-center gap-1.5 rounded-[var(--radius)] font-medium whitespace-nowrap transition-colors focus-visible:ring-2 focus-visible:ring-ring/40 focus-visible:outline-none disabled:opacity-50 disabled:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0',
    {
        variants: {
            variant: {
                default:
                    'bg-primary text-primary-foreground hover:bg-primary/90',
                secondary:
                    'border border-border bg-card hover:bg-secondary text-foreground',
                tertiary:
                    'border border-border bg-card hover:bg-secondary text-foreground',
                outline:
                    'border border-border bg-card hover:bg-secondary text-foreground',
                ghost: 'hover:bg-secondary text-foreground',
                link: 'text-primary underline-offset-4 hover:underline',
                destructive:
                    'bg-destructive text-destructive-foreground hover:bg-destructive/90',
                success:
                    'bg-success text-success-foreground hover:bg-success/90',
            },
            size: {
                xs: 'h-6 px-2 text-[11px]',
                sm: 'h-7 px-2.5 text-[12px]',
                default: 'h-8 px-3 text-[13px]',
                lg: 'h-9 px-4 text-sm',
                icon: 'size-8',
                'icon-sm': 'size-7',
            },
        },
        defaultVariants: {
            variant: 'default',
            size: 'default',
        },
    }
)

function Button({
    className,
    variant,
    size,
    type = 'button',
    ref,
    ...props
}: React.ComponentProps<'button'> & VariantProps<typeof buttonVariants>) {
    return (
        <button
            ref={ref}
            type={type}
            data-slot='button'
            className={cn(buttonVariants({ variant, size }), className)}
            {...props}
        />
    )
}

export { Button, buttonVariants }
